import { Component, Host, h, Prop, State, Method } from "@stencil/core";
import { FlyoutWithButtonProps } from "./f-flyout-with-button-model";

@Component({
  tag: "f-flyout-with-button",
  // shadow: true,
})
export class FlyoutWithButton {
  @Prop() flyoutTitle: FlyoutWithButtonProps["flyoutTitle"] = "";
  @Prop() flyoutId: FlyoutWithButtonProps["flyoutId"];
  @Prop() buttonBadgeLabel: FlyoutWithButtonProps["buttonBadgeLabel"] = "";
  @Prop() buttonIconName: FlyoutWithButtonProps["buttonIconName"] = "";
  @Prop() iconPosition: FlyoutWithButtonProps["iconPosition"] = "left";
  @Prop() flyoutDataTest: FlyoutWithButtonProps["flyoutDataTest"];
  @Prop()
  closeButtonHiddenLabel: FlyoutWithButtonProps["closeButtonHiddenLabel"];
  @Prop() buttonTitle: FlyoutWithButtonProps["buttonTitle"];
  @Prop() variant: FlyoutWithButtonProps["variant"];
  @Prop() iconOnly: FlyoutWithButtonProps["iconOnly"] = true;

  @State() buttonElement;

  private flyout;

  @Method()
  async openFlyout(focusOnFlyout) {
    this.flyout.openFlyout(this.buttonElement, focusOnFlyout);
  }

  @Method()
  async toggleFlyout() {
    this.flyout.toggleFlyout(this.buttonElement);
  }

  @Method()
  async closeFlyout(moveFocus: boolean) {
    this.flyout.closeFlyout(moveFocus);
  }

  render() {
    return (
      <Host>
        <f-button-with-badge
          badgeLabel={this.buttonBadgeLabel}
          iconName={this.buttonIconName}
          onClick={() => this.toggleFlyout()}
          ref={(el) => (this.buttonElement = el)}
          data-test={`flyout-button-${this.buttonTitle}`}
          buttonTitle={this.buttonTitle}
          iconPosition={this.iconPosition}
          iconOnly={this.iconOnly}
        >
          <slot />
        </f-button-with-badge>
        <f-flyout
          ref={(el) => (this.flyout = el)}
          attachedTrigger={this.buttonElement}
          flyoutTitle={this.flyoutTitle}
          flyoutId={this.flyoutId}
          closeButtonHiddenLabel={this.closeButtonHiddenLabel}
          flyoutDataTest={this.flyoutDataTest}
          variant={this.variant}
        >
          <slot name="flyout-styles" slot="flyout-styles" />
          <slot name="flyout-feature-bar" slot="flyout-feature-bar" />
          <slot name="flyout-content" slot="flyout-content" />
          <slot name="flyout-footer" slot="flyout-footer" />
        </f-flyout>
      </Host>
    );
  }
}
